// Desarrollo
// export const baseURL = process.env.NODE_ENV === "development" ? "http://localhost:3004/becas" : "https://desarrollospi.quimica.unam.mx:3004/becas";
// export const baseFrontURL = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://desarrollospi.quimica.unam.mx:4016';

// Producción
export const baseURL = 'https://api.quimica.unam.mx/bowser/becas'
export const baseFrontURL = 'https://becas.quimica.unam.mx';


export const URL_RECOVERY_PASSWORD = 'https://escolares.quimica.unam.mx/recuperar-clave'


export function headersTok(data) {
  const { tok, accion } = data;
  return {
    headers: {
      "x-api-key": tok,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": accion,
      "Access-Control-Allow-Headers": "application/json",
      "content-type": "application/json",
    },
  };
}

export function headersST(accion) {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": accion,
      "Access-Control-Allow-Headers": "application/json",
      "content-type": "application/json",
    },
  };
}

export const errorResponse = {
  replyCode: 500,
  replyText: "Error desconocido, contactar a Planeación",
};

export const definido = (value) =>
  value !== undefined && value !== "" && value !== null;

export const arrayDefinido = (value) =>
  Array.isArray(value) && value.length > 0;

export const objetoDefinido = (value) =>
  definido(value) && Object.keys(value).length > 0;

export const getFechaActual = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2); // Agregar un cero adelante si es necesario
    let day = ('0' + date.getDate()).slice(-2); // Agregar un cero adelante si es necesario
    let formattedDate = year + '-' + month + '-' + day;
    return formattedDate;
  }

export const  isMinorThanTodayDate = (date) => {
    const dateSplitted = date.split('-');
    const formattedDate = new Date(Number(dateSplitted[0]), Number(dateSplitted[1]) - 1, Number(dateSplitted[2]));
    const today = new Date();
    formattedDate.setHours(0,0,0,0) 
    today.setHours(0,0,0,0)
    return formattedDate < today;
  }

export const  isMinorOrEqualThanTodayDate = (date) => {
    const dateSplitted = date.split('-');
    const formattedDate = new Date(Number(dateSplitted[0]), Number(dateSplitted[1]) - 1, Number(dateSplitted[2]));
    const today = new Date();
    formattedDate.setHours(0,0,0,0)
    today.setHours(0,0,0,0)
    return formattedDate <= today;
  }


export const  isGreaterOrEqualThanTodayDate = (date) => {
    const dateSplitted = date.split('-');
    const formattedDate = new Date(Number(dateSplitted[0]), Number(dateSplitted[1]) - 1, Number(dateSplitted[2]));
    const today = new Date();
    formattedDate.setHours(0,0,0,0)
    today.setHours(0,0,0,0)
    return formattedDate >= today;
  }


export const  isGreaterThanTodayDate = (date) => {
    const dateSplitted = date.split('-');
    const formattedDate = new Date(Number(dateSplitted[0]), Number(dateSplitted[1]) - 1, Number(dateSplitted[2]));
    const today = new Date();
    formattedDate.setHours(0,0,0,0)
    today.setHours(0,0,0,0)
    return formattedDate > today;
  }

export const parseDate = (date, monthNames = false) => {
  if (!date) return '';
  if (date.includes('-')) {
    let [year, month, day] = date.split('-');
    let meses = {
      '01': 'enero',
      '02': 'febrero',
      '03': 'marzo',
      '04': 'abril',
      '05': 'mayo',
      '06': 'junio',
      '07': 'julio',
      '08': 'agosto',
      '09': 'septiembre',
      '10': 'octubre',
      '11': 'noviembre',
      '12': 'diciembre',
    };
    return monthNames ? `${day} de ${meses[month] || ''} de ${year}` : `${day}/${month}/${year}`;
  }
  return date;
}